import styled from '@emotion/styled'

export const TabsWrapper = styled.header`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
`

export const Container = styled.div`
  display: flex;
  align-content: center;
  flex-grow: 1;
  justify-content: center;
  height: 225px;
`
